export default function ({ $gtm }) {
  const tags = process.env.gtmId?.trim();
  if (tags) tags.split(',').forEach((tag) => $gtm.init(tag))
}
